const rankingItems = [
  { rank: 1, title: '某千万粉网红私密聊天记录全曝光', tag: '网红爆料', hot: '128.6万', change: 'up' },
  { rank: 2, title: '顶流艺人深夜私会神秘女子完整视频', tag: '明星八卦', hot: '96.3万', change: 'up' },
  { rank: 3, title: '选秀节目选手黑历史被扒，参赛资格遭质疑', tag: '综艺揭秘', hot: '87.5万', change: 'new' },
  { rank: 4, title: 'MCN机构内部运营黑幕，多名博主解约', tag: '深度扒皮', hot: '73.2万', change: 'up' },
  { rank: 5, title: '知名品牌代言人合约纠纷内幕全揭秘', tag: '商业爆料', hot: '65.8万', change: 'down' },
  { rank: 6, title: '综艺录制现场争执画面流出，导演叫停', tag: '综艺揭秘', hot: '52.4万', change: 'new' },
  { rank: 7, title: '头部主播被指数据造假，审计报告疑流出', tag: '独家首发', hot: '48.1万', change: 'up' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时热度排行，看看大家都在追哪些黑料大瓜
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, i) => {
            const rankColor =
              item.rank === 1
                ? 'text-accent-500'
                : item.rank === 2
                ? 'text-accent-400'
                : item.rank === 3
                ? 'text-primary-500'
                : 'text-foreground-400';

            const changeIcon =
              item.change === 'up'
                ? 'ri-arrow-up-line text-green-500'
                : item.change === 'down'
                ? 'ri-arrow-down-line text-red-400'
                : 'ri-sparkling-line text-accent-500';

            return (
              <div
                key={i}
                className={`flex items-center gap-4 px-5 md:px-6 py-4 ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                } hover:bg-background-50 transition-colors cursor-pointer`}
              >
                <div className={`w-8 text-center font-heading font-bold text-lg md:text-xl ${rankColor}`}>
                  {item.rank <= 3 ? (
                    <span className={`text-2xl ${rankColor}`}>
                      {item.rank === 1 ? '👑' : item.rank === 2 ? '🥈' : '🥉'}
                    </span>
                  ) : (
                    <span className="text-sm">{`0${item.rank}`}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 mt-0.5 inline-block whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
                  <i className={`${changeIcon} text-sm`}></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}